import { defineStore } from 'pinia'
import type { UserBankItem } from '~/composables/account/interface'
import type { NetworkTelecom, PaymentBankSchedule, EwalletItem, CryptoItem } from '~composables/deposit/interface'

interface DepositState {
  ewalletCode: string
  ewallet: EwalletItem[]
  networkTelecoms: NetworkTelecom[]
  withdrawBanks: UserBankItem[]
  bankSchedules: PaymentBankSchedule[]
  cryptos: CryptoItem[]
  cryptoTimeLeft: number
  statusNetworkTelecom: boolean
}
const STORE_NAME = 'depositStore'

export const useDepositStore = defineStore(STORE_NAME, {
  state: (): DepositState => ({
    ewalletCode: '',
    networkTelecoms: [],
    ewallet: [],
    withdrawBanks: [],
    bankSchedules: [],
    cryptos: [],
    cryptoTimeLeft: 0,
    statusNetworkTelecom: true
  }),
  persist: false,
  actions: {
    setEwalletCode(code: string) {
      this.ewalletCode = code
    },
    setEwallet(listEwallet: EwalletItem[]) {
      this.ewallet = listEwallet
    },
    setCryptos(listCrypto: CryptoItem[] | CryptoItem) {
      if (Array.isArray(listCrypto)) {
        this.cryptos = listCrypto
        return
      }
      this.cryptos = [listCrypto]
    },
    setNetworkTelecoms(telecoms: NetworkTelecom[]) {
      this.networkTelecoms = telecoms
    },
    setStatusNetworkTelecom(status: boolean) {
      this.statusNetworkTelecom = status
    },
    setWithdrawBanks(banks: UserBankItem[]) {
      this.withdrawBanks = banks
    },
    setBankSchedules(data: PaymentBankSchedule[]) {
      this.bankSchedules = data
    }
  }
})
